export const displayTextVariants = {
  d2xl: {
    fontSize: '4.5rem',
    lineHeight: '5.625rem',
    letterSpacing: '-2%',
  },
  dxl: {
    fontSize: '3.75rem',
    lineHeight: '4.625rem',
    letterSpacing: '-2%',
  },
  dlg: {
    fontSize: '3rem',
    lineHeight: '3.75rem',
    letterSpacing: '-2%',
  },
  dmd: {
    fontSize: '2.25rem',
    lineHeight: '2.75rem',
    letterSpacing: '-2%',
  },
  dsm: {
    fontSize: '1.875rem',
    lineHeight: '2.375rem',
  },
  dxs: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
};

export const textVariants = {
  txl: {
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
  },
  tlg: {
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
  },
  tmd: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  tsm: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  txs: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
  },
};
